import _ from 'lodash'

import {
  SET_MANAGER_LIST,
  SET_BACKUP_MANAGER_INFO,
  SET_SELECTED_MANAGER_INFO,
  SET_SELECTED_MANAGER_DEPARTMENT,
  SET_SELECTED_MANAGER_EMAIL,
  SET_SELECTED_MANAGER_NOTE,
  SET_SELECTED_MANAGER_PHONE,
  SET_SELECTED_MANAGER_POSITION_ID,
  SET_SELECTED_MANAGER_NUMBER,
  SET_SEARCH_FORM,
  SET_COMPLAIN_LIST,
  SET_PAGING,
  SET_CURRENT_PAGE,
  SET_DRIVER_LIST,
  SET_TYPE_LIST,
  SET_IS_SEARCH_BTN_LOADING,
  SET_IS_TABLE_LOAGING,
  SET_CURRENT_LOGIN_SERVICE_ID,
  SET_IS_ADD_COMPLAIN_DIALOG,
  SET_IS_ADD_EVENT_DIALOG,
  SET_IS_UPDATE_COMPLAIN_DIALOG,
  SET_UPDATE_COMPLAIN_DIALOG,
  SET_UPDATE_COMPLAIN_ID,
  SET_TEAM_ROLES,
} from './mutation-types'

export default {
  [SET_MANAGER_LIST](state, managerList) {
    state.managerList = _.cloneDeep(managerList)
  },
  [SET_BACKUP_MANAGER_INFO](state, managerInfo) {
    if (managerInfo) {
      state.backupManagerInfo = managerInfo
    }
  },
  [SET_SELECTED_MANAGER_INFO](state, managerInfo) {
    if (managerInfo) {
      state.selectedManagerInfo = managerInfo
    }
  },
  [SET_SELECTED_MANAGER_DEPARTMENT](state, department) {
    state.selectedManagerInfo.department = department
  },
  [SET_SELECTED_MANAGER_EMAIL](state, email) {
    state.selectedManagerInfo.email = email
  },
  [SET_SELECTED_MANAGER_NOTE](state, note) {
    state.selectedManagerInfo.note = note
  },
  [SET_SELECTED_MANAGER_PHONE](state, phone) {
    state.selectedManagerInfo.phone = phone
  },
  [SET_SELECTED_MANAGER_POSITION_ID](state, positionId) {
    state.selectedManagerInfo.positionId = positionId
  },
  [SET_SELECTED_MANAGER_NUMBER](state, serviceNumber) {
    state.selectedManagerInfo.serviceNumber = serviceNumber
  },
  [SET_IS_ADD_COMPLAIN_DIALOG](state, isAddComplainDialog) {
    state.isAddComplainDialog = isAddComplainDialog
  },
  [SET_IS_ADD_EVENT_DIALOG](state, isAddEventDialog) {
    state.isAddEventDialog = isAddEventDialog
  },
  [SET_IS_UPDATE_COMPLAIN_DIALOG](state, isUpdateComplainDialog) {
    state.isUpdateComplainDialog = isUpdateComplainDialog
  },
  [SET_UPDATE_COMPLAIN_DIALOG](state, updateComplainDialog) {
    state.updateComplainDialog = updateComplainDialog
  },
  [SET_UPDATE_COMPLAIN_ID](state, id) {
    state.updateComplainId = id
  },
  [SET_SEARCH_FORM](state, form) {
    state.searchForm = form
  },
  [SET_COMPLAIN_LIST](state, complainList) {
    state.complainList = complainList
  },
  [SET_PAGING](state, paging) {
    state.paging = paging
  },
  [SET_CURRENT_PAGE](state, currentPage) {
    state.paging.currentPage = currentPage
  },
  [SET_DRIVER_LIST](state, driverList) {
    state.driverList = driverList
  },
  [SET_TYPE_LIST](state, typeList) {
    state.typeList = typeList
  },
  [SET_IS_SEARCH_BTN_LOADING](state, isLoading) {
    state.isSearchBtnLoading = isLoading
  },
  [SET_IS_TABLE_LOAGING](state, isLoading) {
    state.isTableLoading = isLoading
  },
  [SET_CURRENT_LOGIN_SERVICE_ID](state, currentLoginServiceId) {
    state.currentLoginServiceId = currentLoginServiceId
  },
  [SET_TEAM_ROLES](state, teamRoles) {
    // 確保 teamRoles 是陣列，如果沒有則設為空陣列
    state.teamRoles = Array.isArray(teamRoles) ? [...teamRoles] : []
  },
}



// WEBPACK FOOTER //
// ./src/store/managerStore/mutations.js